import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../../SharedComponents/Header/Header";

function StoreLayout() {
  return (
    <div>
      <Header />
      <Outlet />
    </div>
  );
}

export default StoreLayout;
